import { render, staticRenderFns } from "./attach-list.vue?vue&type=template&id=3c90f508&scoped=true"
import script from "./attach-list.vue?vue&type=script&lang=js"
export * from "./attach-list.vue?vue&type=script&lang=js"
import style0 from "./attach-list.vue?vue&type=style&index=0&id=3c90f508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c90f508",
  null
  
)

export default component.exports